import { addQueryArgs } from '@wordpress/url';
import { getOrderParams } from '../mixins/review-list';

const reviewNode = document.querySelector( '.realpress-property-review-wrap' );
let reviewContainerNode, sortNode, paginationWrapNode, paginationNode, formNode, propertyId, restNamespace;
let data;

const init = () => {
	reviewContainerNode = reviewNode.querySelector( '.realpress-reviews-container' );
	sortNode = reviewNode.querySelector( '.realpress-sort-by select' );
	paginationWrapNode = reviewNode.querySelector( '.realpress-review-pagination-wrap' );
	formNode = reviewNode.querySelector( 'form' );
	propertyId = REALPRESS_SINGLE_PROPERTY_PAGE.property_id || '';
	restNamespace = REALPRESS_GLOBAL_OBJECT.rest_namespace || '';
	data = { offset: 1, orderby: 'date', order: 'DESC', property_id: propertyId, type: 'property' };
};

const realpressReview = () => {
	if ( ! reviewNode ) {
		return;
	}
	init();

	if ( sortNode ) {
		getReview( data );
		//sort
		sortNode.addEventListener( 'change', function( event ) {
			let offset = 1;

			paginationNode = paginationWrapNode.querySelector( '.realpress-pagination' );

			if ( paginationNode ) {
				offset = paginationNode.querySelector( 'li.current a' ).getAttribute( 'data-page' );
			}
			const selected = event.target.value;
			const sortParams = getOrderParams( selected );
			data = { ...data, ...sortParams, offset };
			getReview( data );
		} );
	}

	if ( !! formNode ) {
		addReview();
	}
};

const addReview = () => {
	reviewNode.querySelector( '#realpress-submit-review' ).addEventListener( 'click', function( event ) {
		event.preventDefault();
		this.disabled = true;
		const messageNode = reviewNode.querySelector( '.realpress-form-message' );
		const rating = reviewNode.querySelector( '#realpress-review-rating' ).value;
		const content = reviewNode.querySelector( '#realpress-review-content' ).value;
		let data = { property_id: propertyId, rating, content ,type: 'property'};

		wp.apiFetch( {
			path: '/' + restNamespace + '/comments',
			method: 'POST',
			data,
		} ).then( ( res ) => {
			if ( !! res.msg ) {
				messageNode.classList.remove('failed');
				messageNode.classList.add('success');
				messageNode.innerHTML = res.msg;
			}
		} ).catch( ( err ) => {
			if ( !! err.msg ) {
				messageNode.classList.remove('success');
				messageNode.classList.add('failed');
				messageNode.innerHTML =  err.msg ;
			}
		} ).finally( () => {
			this.disabled = false;
			messageNode.scrollIntoView( { behavior: 'smooth' } );
		} );
	} );
};

const getReview = ( data = {} ) => {
	reviewContainerNode.style.opacity = 0.4;
	wp.apiFetch( {
		path: addQueryArgs( '/' + restNamespace + '/comments', data ),
		method: 'GET',
	} ).then( ( res ) => {
		if ( !! res.data.content ) {
			reviewContainerNode.innerHTML = res.data.content;
		}
		if ( !! res.data.pagination ) {
			paginationWrapNode.innerHTML = res.data.pagination;
		}

		paginationNode = paginationWrapNode.querySelector( '.realpress-pagination' );
		if ( !! paginationNode ) {
			const pageNodes = paginationNode.querySelectorAll( 'a' );
			for ( let i = 0; i < pageNodes.length; i++ ) {
				pageNodes[ i ].addEventListener( 'click', function( event ) {
					event.preventDefault();
					const offset = this.getAttribute( 'data-page' );
					getReview( { ...data, offset } );
					sortNode.scrollIntoView( { behavior: 'smooth' } );
				} );
			}
		}
	} ).catch( ( err ) => {
		if ( !! err.msg ) {
			console.log( err.msg );
		}
	} ).finally( () => {
		reviewContainerNode.style.opacity = 1;
	} );
};

export default realpressReview;
